import type { AuthUserType } from '@econtractor/types';

type AccessField =
    | 'prodEdit'
    | 'objectCreate'
    | 'proposalCreate'
    | 'warehouseOps'
    | 'reportsView'
    | 'teamsEdit'
    | 'tasksViewAll';

export const hasUserAccess = (user: AuthUserType | null | undefined, field: AccessField): boolean => {
    if (!user) return false;
    if (user.admin) return true;
    return !!user.access?.[field];
};

export const canWarehouseOps = (user: AuthUserType | null | undefined): boolean => {
    if (!user) return false;
    if (user.admin) return true;
    if (user.access?.role !== 'manager') return true;
    return !!user.access?.warehouseOps;
};

/** Адмін або менеджер з доступом «Доступ до всіх задач» */
export const canViewAllTasks = (user: AuthUserType | null | undefined): boolean => {
    if (!user) return false;
    if (user.admin) return true;
    return user.access?.role === 'manager' && !!user.access?.tasksViewAll;
};
